module.exports = __webpack_public_path__ + "img/four4Green.d2da520a.jpg";